import { createContext, useContext, useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import apiFactory from "../api";
import { useInfoUser } from "../store/UserStore";

const AdminSettingContext = createContext(null);

export const useAdminSettingContext = () => {
  return useContext(AdminSettingContext);
};

export const AdminSettingProvider = ({ children }) => {
  const navigate = useNavigate();
  const { languageMap, user } = useInfoUser();
  const [isGeneralLoading, setIsGeneralLoading] = useState(false);
  const [isProgramLoading, setIsProgramLoading] = useState(false);
  const [programList, setProgramList] = useState([]);
  const [selectedProgram, setSelectedProgram] = useState();
  const [isVerify, setIsVerify] = useState(false);
  const [selectedApp, setSelectedApp] = useState(null);
  const [versionList, setVersionList] = useState([]);

  const fetchProgramList = async () => {
    setIsProgramLoading(true);
    try {
      const request = {
        // program: "",
        // date: "",
      };

      const result = await apiFactory.resourceApi.summaryAll(request);
      if (result?.status === 200) {
        setProgramList(
          result?.data?.map((program) => ({
            ...program,
            key: program?.program,
          }))
        );
      }
    } catch (error) {
      console.error("Error fetching alarm list data:", error);
    } finally {
      setIsProgramLoading(false);
    }
  };

  useEffect(() => {
    if (user) {
      if (user.roleCode === "ADMIN") {
        setIsVerify(true);
      } else {
        navigate("/conversation");
      }
    }
  }, [user]);

  const values = useMemo(
    () => ({
      programList,
      setProgramList,
      setSelectedProgram,
      selectedProgram,
      isGeneralLoading,
      setIsGeneralLoading,
      fetchProgramList,
      isProgramLoading,
      setIsProgramLoading,
      isVerify,
      selectedApp,
      setSelectedApp,
      versionList, setVersionList
    }),
    [
      programList,
      selectedProgram,
      isGeneralLoading,
      isProgramLoading,
      isVerify,
      selectedApp,
      versionList
    ]
  );

  return (
    <AdminSettingContext.Provider value={values}>
      {children}
    </AdminSettingContext.Provider>
  );
};
